import { client } from "api";

export type SetDocumentationDoneRequest = { checklistId: string; documentationDone: boolean };
export type SetDocumentationDoneResponse = { checklistId: string; documentationDone: boolean };

export const setDocumentationDone = (params: SetDocumentationDoneRequest) =>
  client
    .post<SetDocumentationDoneResponse>(`/checklist/set-documentation-done`, params)
    .then((res) => res.data);
